<template>
  <div :style="{ margin: '2rem' }">
    <RecordsClients/>
    <RecordsReserves/>
    <RealStates/>
    <ReserveInfos/>
  </div>
</template>
<script>

import RecordsClients from './RecordsClients'
import RecordsReserves from './RecordsReserves'
import RealStates from './RealStates'
import ReserveInfos from './ReserveInfos.vue'

export default {
  components: {
    RecordsClients,
    RecordsReserves,
    RealStates,
    ReserveInfos
  }
}
</script>

<style>
.graphic-space {
  margin-top: 60px;
}
</style>


// WEBPACK FOOTER //
// src/components/dashboards/Dashboard.vue